module.exports = __webpack_public_path__ + "images/home_2048.jpg";